import http from "@/axios";
import {
    ArtifactInfo,
    GroupInfo,
    RuneInfo,
    SpeedupInfo,
    UnlockInfo,
    UpdateInfo
} from "@/store/artifact/types";
import {Player} from "@/store/player/types";
import PlayerStore from "@/store/player";
import {WarriorClass} from "@/store/level/types";

export default class ArtifactStore {

    public static groupInfo(artifactId: string): Promise<GroupInfo> {
        return http.get('/api/artifact/group/info/' + artifactId)
            .then(r => r.data)
            .then(groupInfo => {
                return Object.assign(new GroupInfo(), groupInfo);
            });
    };

    public static artifactPlaceInfo(placeId: number): Promise<ArtifactInfo> {
        return http.get('/api/artifact/artifactPlaceInfo?placeId=' + String(placeId))
            .then(r => r.data)
            .then(artifactInfo => {
                let ai: ArtifactInfo = Object.assign(new ArtifactInfo(), artifactInfo);
                return ai;
            });
    };

    public static runePlaceInfo(placeId: number): Promise<RuneInfo> {
        return http.get('/api/artifact/runePlaceInfo?placeId=' + String(placeId))
            .then(r => r.data)
            .then(runeInfo => {
                let ri: RuneInfo = Object.assign(new RuneInfo(), runeInfo);
                return ri;
            });
    };

    public static artifactsReadyForUpdate(): Promise<string[]> {
        return http.get('/api/artifact/artifactsReadyForUpdate')
            .then(r => r.data)
            .then(listObj => {
                let artifactIds: string[] = Object.assign([], listObj);
                return artifactIds;
            });
    };

    public static updateInfo(artifactId: number): Promise<UpdateInfo | undefined> {
        return http.get('/api/artifact/updateInfo?artifactId=' + String(artifactId))
            .then(r => r.data)
            .then(updateInfo => {
                if (!updateInfo) {
                    return undefined;
                }
                let ui: UpdateInfo = Object.assign(new UpdateInfo(), updateInfo);
                return ui;
            });
    };

    public static artifactsInfoByCreature(creatureId: number): Promise<UpdateInfo[]> {
        return http.get('/api/artifact/getArtifactsInfoByCreature?creatureId=' + String(creatureId))
            .then(r => r.data)
            .then(listObj => {
                let ui: UpdateInfo[] = Object.assign([], listObj);
                return ui;
            });
    };

    public static speedupInfo(artifactId: number): Promise<SpeedupInfo | undefined> {
        return http.get('/api/artifact/speedupInfo?artifactId=' + String(artifactId))
            .then(r => r.data)
            .then(speedupInfo => {
                if (!speedupInfo) {
                    return undefined;
                }
                let si: SpeedupInfo = Object.assign(new SpeedupInfo(), speedupInfo);
                return si;
            });
    };

    public static unlockInfo(creatureId: number): Promise<UnlockInfo | undefined> {
        return http.get('/api/artifact/unlockInfo?creatureId=' + String(creatureId))
            .then(r => r.data)
            .then(unlockInfo => {
                if (!unlockInfo) {
                    return undefined;
                }
                let ui: UnlockInfo = Object.assign(new UnlockInfo(), unlockInfo);
                return ui;
            });
    };

    public static replaceInfo(artifactId: number): Promise<ArtifactInfo> {
        return http.get('/api/artifact/' + String(artifactId) + '/replaceInfo')
            .then(r => r.data)
            .then(artifactInfo => {
                let ai: ArtifactInfo = Object.assign(new ArtifactInfo(), artifactInfo);
                return ai;
            });
    };

    public static takeArtifactFromRoad(placeId: number, creatureId: number): Promise<Player> {
        var params = new URLSearchParams();
        params.append('placeId', String(placeId));
        params.append('creatureId', String(creatureId));

        return http.post('/api/artifact/takeArtifactFromRoad', params)
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    };

    public static unlockSlot(creatureId: number): Promise<Player> {
        var params = new URLSearchParams();
        params.append('creatureId', String(creatureId));

        return http.post('/api/artifact/unlockSlot', params)
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    };

    public static takeRuneFromRoad(placeId: number): Promise<Player> {
        var params = new URLSearchParams();
        params.append('placeId', String(placeId));

        return http.post('/api/artifact/takeRuneFromRoad', params)
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    };

    public static speedupUpdate(artifactId: number): Promise<Player> {
        var params = new URLSearchParams();
        params.append('artifactId', String(artifactId));

        return http.post('/api/artifact/speedupUpdate', params)
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    };

    public static startUpdate(artifactId: number): Promise<Player> {
        var params = new URLSearchParams();
        params.append('artifactId', String(artifactId));

        return http.post('/api/artifact/startUpdate', params)
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    };

    public static actualizeArtifacts(): Promise<void> {
        return http.post('/api/artifact/actualizeArtifacts')
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
            });
    };

    public static isTimeToActualize(): Promise<boolean> {
        return http.get('/api/artifact/isTimeToActualize')
            .then(r => r.data)
            .then(isTimeObj => {
                return JSON.parse(isTimeObj);
            });
    };

    public static clearNotifications(): Promise<Player> {
        return http.post('/api/artifact/clearNotifications')
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    };

    public static deleteNotification(notificationId: number): Promise<Player> {
        var params = new URLSearchParams();
        params.append('notificationId', String(notificationId));

        return http.post('/api/artifact/deleteNotification', params)
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    };

    public static replaceArtifact(artifactId: number, creatureId: number): Promise<Player> {
        var params = new URLSearchParams();
        params.append('creatureId', String(creatureId));
        return http.post('/api/artifact/' + String(artifactId) + '/replace', params)
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    };

    public static refineArtifact(artifactId: number, creatureId: number, placeId: number): Promise<Player> {
        var params = new URLSearchParams();
        params.append('creatureId', String(creatureId));
        params.append('placeId', String(placeId));
        return http.post('/api/artifact/' + String(artifactId) + '/refine', params)
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    };

    public static getGroupUpgradeAvailable(creatureId?: number): Promise<UpdateInfo[]> {
        return http.get('/api/artifact/group/upgradeAvailable' + (creatureId ? '?creatureId=' + creatureId : ''))
            .then(r => r.data)
            .then(list => Object.assign([], list));
    }

    public static startGroupUpgrade(artifactIds: number[]): Promise<void> {
        const params = new URLSearchParams();
        artifactIds.forEach(id => params.append('artifactIds', String(id)));
        return http.post('/api/artifact/group/upgrade', params).then(r => r.data);
    }
}
